<template>
    <bill-print-dialog :state="dialog" :bill="bill" />
</template>
<script>
import BillPrintDialog from '@/modules/bill/BillPrintDialog.vue'
import utils from '@/plugins/utils.js'
export default {
  components: {
    BillPrintDialog,
  },
  props: {
    bill: Object,
    state: Boolean,
  },

  data() {
    return {
      dialog: false,
    }
  },
  watch: {
    state(state) {
      this.dialog = !this.dialog
    },
  },
}
</script>
<style scoped>
td {
  border: none !important;
  padding: 4px 8px !important;
  height: auto;
}
</style>
